<template>
  <div class="product-safety-content additional-info">
    <div class="title-area">
      <div class="title">Ek Bilgiler</div>
      <div class="description">Ürün güvenliği ek bilgileri; kullanım talimatı, materyal bileşeni, bakım talimatı, CE uygunluk sembolü, yıkama talimatı, ürün uyarı sembolleri, ürün güvenliği uyarıları, içerik listesi, tamir edilebilirlik bilgilerini içerir.</div>
    </div>
    <div class="product-safety-content-boxes">
      <div class="box">
        <Input 
          type="textarea" 
          label="Kullanım Talimatı" 
          id="usage-instruction"
          v-model:value="formData.usageInstructions"
        />
        <Input 
          type="textarea" 
          label="Bakım Talimatı" 
          id="maintenance-instruction"
          v-model:value="formData.careInstructions"
        />
        <Input 
          type="textarea" 
          label="Ürün Uyarı Sembolleri" 
          id="product-warning-symbols"
          v-model:value="formData.productWarningSymbols"
        />
        <Input 
          type="textarea" 
          label="İçerik Listesi" 
          id="content-list"
          v-model:value="formData.contentList"
        />
        <DropdownSelectable
          :key="`ce-compliance-${formData.ceCompliance}`"
          label="CE Uygunluk Sembolü" 
          id="ce-approval-symbol"
          :dropItems="ceOptions"
          :isRadioGroup="true"
          :isShowSearch="false"
          :preSelectedRadioItem="ceOptions.find(o => o.value === formData.ceCompliance)"
          @selectedRadioItem="formData.ceCompliance = $event?.value"
        />
      </div>
      <div class="box">
        <Input 
          type="textarea" 
          label="Materyal Bileşeni" 
          id="material-component"
          v-model:value="formData.materialComponent"
        />
        <Input 
          type="textarea" 
          label="Yıkama Talimatı" 
          id="washing-instruction"
          v-model:value="formData.washingInstructions"
        />
        <Input 
          type="textarea" 
          label="Ürün Güvenliği Uyarıları" 
          id="product-safety-warnings"
          v-model:value="formData.productSafetyWarnings"
        />
        <Input 
          type="textarea" 
          label="Tamir Edilebilirlik" 
          id="repairability"
          v-model:value="formData.repairability"
        />
      </div>
    </div>
  </div>
  </template>
  
  <script setup>
  import { reactive } from 'vue';
  import { DropdownSelectable, Input } from "@n11/so-ui-components";
  
  const ceOptions = [
    { id: 'var', name: 'Var', value: true },
    { id: 'yok', name: 'Yok', value: false }
  ];
  
  const formData = reactive({
    usageInstructions: '',
    careInstructions: '',
    productWarningSymbols: '',
    contentList: '',
    materialComponent: '',
    washingInstructions: '',
    productSafetyWarnings: '',
    repairability: '',
    ceCompliance: null
  });
  
  const getData = () => {
    const data = {};
    
    Object.keys(formData).forEach(key => {
      if (formData[key] !== '' && formData[key] !== null) {
        data[key] = formData[key];
      }
    });
    
    return data;
  };
  
  const loadTemplateData = (data) => {
    try {
      if (!data) {
        return;
      }
      if (data.usageInstructions) formData.usageInstructions = data.usageInstructions;
      if (data.careInstructions) formData.careInstructions = data.careInstructions;
      if (data.productWarningSymbols) formData.productWarningSymbols = data.productWarningSymbols;
      if (data.contentList) formData.contentList = data.contentList;
      if (data.materialComponent) formData.materialComponent = data.materialComponent;
      if (data.washingInstructions) formData.washingInstructions = data.washingInstructions;
      if (data.productSafetyWarnings) formData.productSafetyWarnings = data.productSafetyWarnings;
      if (data.repairability) formData.repairability = data.repairability;
      if (data.ceCompliance !== undefined && data.ceCompliance !== null) {
        formData.ceCompliance = data.ceCompliance;
      }
    } catch (error) {
      console.error('ProductSafetyAdditionalInfo - loadTemplateData hatası:', error);
    }
  };
  
  defineExpose({ getData, loadTemplateData });
  </script>
  
  <style lang="scss" scoped>
  @import "@/assets/styles/variables.scss";
  
  .product-safety-content,
  .box {
    .title-area {
      .title {
        font-size: 14px;
        font-weight: 600;
        line-height: 18px;
        letter-spacing: -0.05px;
        margin-bottom: 8px;
      }
  
      .description {
        font-size: 11px;
        line-height: 14px; 
        height: 30px;
      }
    }
    &-form-area {
      display: flex;
      flex-direction: column;
      gap: 10px;
      margin: 16px 0px; 
      padding: 24px;
      border-radius: 8px;
      border: 1px solid $colorM10;
      background-color: #F8F7FC;
    }
  }
  .box {
    flex: 1;
  
    div {
      margin-bottom: 10px;
    }
  
    &:last-child {
      margin-left: 25px;
    }
  }
  .product-safety-content {
    margin-top: 24px;
    &-boxes {
      display: flex;
      justify-content: space-around;
  
    }
  }
  .error {
    &-text {
      font-size: 11px;
      font-weight: 400;
      line-height: 14px;
      color: $colorE50; 
      margin-left: 12px;
    }
  }
  </style>